@if (occurrencePagesCounter >= 1) {
  <div class="d-flex">
    <div class="fading-div left-fading-div" [ngClass]="{ hide: !displayFadingDivs.left, show: displayFadingDivs.left }"></div>
    <div class="pagination-container d-flex">
      @if (occurrencePagesCounter > 1) {
        <div class="previous flex-center-center" (click)="onPreviousOccurrencePage()">
          <div class="change-page-icon">
            <i class="ph-fill ph-caret-left flex-center-center h-100"></i>
          </div>
        </div>
      }
      <div #fixedContainerScrollable id="fixed-container-scrollable" class="fixed-size-pagination-container">
        <div class="h-100 d-table">
          <div class="pages-part d-table-cell align-middle">
            <div class="page-part-container d-flex">
              @for (representation of pagesRepresentationArray; track trackByPage(i, representation); let i = $index) {
                <div (click)="onClickPage(representation)">
                  @if (representation.style === PageRepresentationTypes.FIRST_OR_LAST_PAGE) {
                    <div class="page first-or-last-page d-table">
                      <div class="d-table-cell align-middle">
                        <span class="d-flex justify-content-center">{{ representation.page }}</span>
                      </div>
                    </div>
                  }
                  @if (representation.style === PageRepresentationTypes.ONE_DOT) {
                    <div
                      [ngClass]="{
                        'current-dots':
                          currentPage > (representation['spread']?.previousPage ?? 0) &&
                          currentPage < (representation['spread']?.nextPage ?? 0) &&
                          pagesRepresentationArray.length > 3,
                      }"
                      class="dots d-table"
                    >
                      <div class="d-table-cell align-middle">
                        <span class="d-flex justify-content-center">•</span>
                      </div>
                    </div>
                  }
                  @if (representation.style === PageRepresentationTypes.THREE_DOTS) {
                    <div
                      [ngClass]="{
                        'current-dots':
                          currentPage > (representation['spread']?.previousPage ?? 0) &&
                          currentPage < (representation['spread']?.nextPage ?? 0) &&
                          pagesRepresentationArray.length > 3,
                      }"
                      class="dots d-table"
                    >
                      <div class="d-table-cell align-middle">
                        <span class="d-flex justify-content-center">•••</span>
                      </div>
                    </div>
                  }
                  @if (representation.style === PageRepresentationTypes.DEFAULT) {
                    <div [ngClass]="{ 'current-page': currentPage === representation.page }" class="page page-with-occurrence d-table">
                      <div class="d-table-cell align-middle">
                        <span class="d-flex justify-content-center">{{ representation.page }}</span>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      @if (occurrencePagesCounter > 1) {
        <div class="next flex-center-center" (click)="onNextOccurrencePage()">
          <div class="change-page-icon">
            <i class="ph-fill ph-caret-right flex-center-center h-100"></i>
          </div>
        </div>
      }
    </div>
    <div class="fading-div right-fading-div" [ngClass]="{ hide: !displayFadingDivs.right, show: displayFadingDivs.right }"></div>
  </div>
}
